import React from "react";
import ItemCategoryList from "../../components/webshop/ItemCategoryList";

const ItemCategoriesPage = () => {
    return <ItemCategoryList/>
}

export default ItemCategoriesPage;
